import type { DeckPressReleaseLink } from '@/entities/deck'

export function useDeckPressRelease() {
  async function createPressReleaseLink(deckId: number | string): Promise<DeckPressReleaseLink> {
    const body = await $fetch<{ uuid: string; created_at: string }>(`v2/decks/${deckId}/press_release_link/`, {
      ...useFetchSharedOptions(),
      method: 'POST',
      body: {},
    })
    return { uuid: body.uuid, created_at: body.created_at }
  }

  async function deletePressReleaseLink(deckId: number | string): Promise<void> {
    await $fetch<void>(`v2/decks/${deckId}/press_release_link/`, {
      ...useFetchSharedOptions(),
      method: 'DELETE',
    })
  }

  return { createPressReleaseLink, deletePressReleaseLink }
}
